/**
 * Centre an overflowed tab in its horizontal scroller (member Detail tabs on
 * narrow viewports). No-op when the strip does not overflow.
 */
export function scrollTabIntoCenter(scroller: HTMLElement, tab: HTMLElement): void {
  const max = scroller.scrollWidth - scroller.clientWidth
  if (max <= 0) return
  const s = scroller.getBoundingClientRect()
  const t = tab.getBoundingClientRect()
  const delta = t.left + t.width / 2 - (s.left + s.width / 2)
  const next = Math.max(0, Math.min(scroller.scrollLeft + delta, max))
  scroller.scrollTo({ left: next, behavior: 'smooth' })
}
